export default "/images/0be50a36945dde1a08707219487b9467.avif";